import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { leadHasPlaceId } from 'router/loaders/utils/validation';
import { signupSearchParams } from 'router/search/signup';
import { beforeLoadSignupSubRoute, headSignupSubRoute } from 'router/utils';
import { validateLeadStatus } from 'router/validateLeadStatus';

import { getActivitiesQueryOptions } from 'services/partnersSelfSignup/activities';
import { getPopularActivitiesQueryOptions } from 'services/partnersSelfSignup/popularActivities';
import { readLeadQueryCache } from 'services/partnersSelfSignup/signup';

export const Route = createFileRoute('/_signup/activities')({
  validateSearch: zodValidator(signupSearchParams),
  head: headSignupSubRoute,
  beforeLoad: ({ context, location, preload, cause }) => {
    const { growthbook } = context;

    return beforeLoadSignupSubRoute({
      context,
      location,
      preload,
      cause,
      validateLeadStatus,
      validation: {
        validate: leadResponse => {
          const { lead } = leadResponse;

          if (!leadHasPlaceId(lead)) {
            throw redirect({ to: '/gym/business-details' });
          }

          const bypassDecision = growthbook.isOn(
            'partners.acquisition.bypass-activities',
          );

          if (bypassDecision) {
            throw redirect({ to: '/pricing' });
          }

          return true;
        },
      },
    });
  },
  loader: async ({ context }) => {
    const { queryClient } = context;

    await queryClient.ensureQueryData(getActivitiesQueryOptions());

    const lead = readLeadQueryCache(
      context.queryClient,
      context.queryVariables,
    );

    const { country = 'us' } = lead?.lead ?? {};

    queryClient.ensureQueryData(getPopularActivitiesQueryOptions({ country }));
  },
});
